import { getRequestState } from '@/logic/requestStatus/reducer'
import type { RootState } from '@/redux/interfaces'

export const getConfirmationState = () => (state: RootState) => getRequestState('makeAccreditationProcess_confirm')(state)
